import classNames from "classnames/bind";
import styles from './Clock.module.css';
import { useEffect, useState } from "react";

const cx = classNames.bind(styles);

function ClockReal({ type_camera = "Other", temperature, fontSize }) {
  const [time, setTime] = useState();

  useEffect(() => {
    const timer = setInterval(() => {
      const date = new Date()
      let da, mo, ye, ho, mnu, se;
      da = date.getDate();
      mo = date.getMonth() + 1;
      ye = date.getFullYear();
      ho = date.getHours();
      mnu = date.getMinutes();
      se = date.getSeconds();
      let t = `${da < 10 ? '0' + da : da}/${mo < 10 ? '0' + mo : mo}/${ye} - ${ho < 10 ? '0' + ho : ho}:${mnu < 10 ? '0' + mnu : mnu}:${se < 10 ? '0' + se : se}`;
      setTime(t)
    }, 1000)
    return () => clearInterval(timer)
  }, [])
  return (
    <div className={cx('wrapper')}>
      <p className={cx('time')} style={fontSize ? { fontSize: fontSize } : { fontSize: 12 }}>{time}</p>
      {type_camera === "HIK" && <p className={cx('time-tem')} style={fontSize ? { fontSize: fontSize + 8 } : { fontSize: 12 }}>{temperature} &#8451;</p>}
    </div>
  )
}

export default ClockReal;